import { useEffect } from 'react';

import type { PCMAudioManager } from '@/lib/pcmAudioManager';

/** Release the microphone if the page unmounts mid-recording (route change).
 * The streaming socket is left alone: it may still be finalizing a transcript. */
export const useStopRecorderOnUnmount = (pcmAudioManagerRef: React.RefObject<PCMAudioManager | null>) => {
  useEffect(() => {
    return () => {
      const manager = pcmAudioManagerRef.current;
      if (!manager) return;
      pcmAudioManagerRef.current = null;
      void manager.stop().catch((err) => console.warn('[Recorder] stop on unmount failed:', err));
    };
  }, [pcmAudioManagerRef]);
};
